<script lang='ts'>
  import * as _ from 'lodash';
  import { HttpPromise } from "@shared/svelte/Modules/ApiService";
  import LoadingSpinner from '@shared/svelte/Components/LoadingSpinner.svelte';
  import ProductContainerDetails from "@shared/filters/product_container_details.js";
  import Icon from "@shared/svelte/Components/Icon.svelte";
  export let productLine;
  import { fade } from 'svelte/transition';

  let selectedProduct;

  const selectSize = function() {
    let obj;
    if (!selectedProduct || !selectedProduct.id) {
      return;
    }
    // regular product
    const alreadySelectedSize = function(product) {
      return (product['_destroy'] === undefined) &&
        product.cloned_from_product_id == selectedProduct.id;
    }
    if (productLine.sell_sheet_products_attributes.some(alreadySelectedSize)) {
      selectedProduct = '';
      return;
    }

    obj = _.merge(selectedProduct, {
      cloned_from_product_id: selectedProduct.id
    });

    const unitPrice = _.get(obj, 'inventory[0].unit_price')
    const casePrice = _.get(obj, 'inventory[0].case_price')

    obj = _.omit(obj, ['id', 'inventory']);
    obj = _.merge(obj, {
      unit_price: unitPrice,
      case_price: casePrice,
      inventory_unit_price: unitPrice,
      inventory_case_price: casePrice
    });
    productLine.sell_sheet_products_attributes.push(obj)
    productLine.sell_sheet_products_attributes = productLine.sell_sheet_products_attributes;
    selectedProduct = '';
  };

  const removeSize = function(product) {
    product['_destroy'] = '1';
    productLine.sell_sheet_products_attributes = productLine.sell_sheet_products_attributes;
  };

  const showCasePrice = function(product) {
    return product.container_type != 'keg'
  };
  let products = [];

  const load = async function() {
    try {
      let res = await HttpPromise({
        method: 'GET',
        url: `/api/distributor/products`,
        data: {
          extended_search: true,
          product_line_id: productLine.cloned_from_product_line_id
        }
      });

      products = res.map(function(product) {
        product.displayName = ProductContainerDetails()(product);
        if (product.inventory.length && product.inventory[0].sku) {
          product.displayName += ` - ${product.inventory[0].sku}`
        }
        return product
      });
    } catch(error) {
      console.error(error)
    }
    return products;
  }

  $: {
    selectedProduct;
    selectSize();
  }
</script>


<div class="margin-bottom--smaller sell-sheet-size-widget-wrapper">
  <div class="label input__label--left padding-bottom--smallest align-left">Select SKUs</div>
  <div class='distributors__add_retailer_account_modal'>
    <div class='distributors_reps__autocomplete position-relative'>
      {#await load()}
        <LoadingSpinner />
      {:then products}
        <select
          class="fizz-select fizz-full-width fizz-stack-24"
          name="product_sheet_product_select"
          id="product_sheet_product_select"
          bind:value={selectedProduct}
        >
          <option value="">{#if products.length}Add any SKU{:else}No SKUs available{/if}</option>
          {#each products as product}
            <option id='product-{product.id}'
              value={product}
            >
              {product.displayName}
            </option>
          {/each}
        </select>
      {/await}
    </div>
  </div>

  {#if productLine.sell_sheet_products_attributes.length > 0}
  <div class="s5 color-black margin-top--smallest size-widget">
    {#each productLine.sell_sheet_products_attributes as product, i (product)}
      {#if !product._destroy}
        <span transition:fade
          id='size-widget-{product.cloned_from_product_id || product.container_size}'
          class='background-grayLight margin-bottom--smallest ellipsis padding--smallest display tile sell-sheet-size-widget'>
          {#if product.inventory_unit_price}
            <span class='custom-price-input unit-price input-wrapper quantity-input vertical-align-middle'>
            $  <input class='input' type='number' disabled={true}
                data-testid='product-unit-price'
                value={product.inventory_unit_price} />
            </span>
          {/if}
          {#if showCasePrice(product)}
            {#if product.inventory_case_price}
              <span class='custom-price-input unit-price input-wrapper quantity-input vertical-align-middle'>
                $ <input class='input' type='number' disabled={true}
                  data-testid='product-case-price'
                  value={product.inventory_case_price} />
              </span>
            {/if}
          {/if}
          {#if !product.inventory_unit_price && !product.inventory_case_price}
            <span>
              Pricing not available:
            </span>
          {/if}
          {ProductContainerDetails()(product) }
          <a class="padding-left--smallest padding-right--smallest w800 cursor-pointer color-red align-right float-right"
            on:click|preventDefault={() => removeSize(product)} href={"#"}>
            <Icon type="X" height="12" width="12"
              extraClassNames="cursor-pointer display-inline-block color-red vertical-align-middle margin-top--smallest" />
          </a>
          <div class='s5 padding-top--smallest fizz-flex fizz-flex-wrap fizz-gap-8' style="display: flex;">
            <span class='custom-price-input unit-quantity input-wrapper quantity-input vertical-align-middle'>
              Suggested Units:
              <input class='input' type='number'
                data-testid='product-unit-quantity'
                bind:value={product.unit_quantity} />
            </span>
            <span class='custom-price-input case-quantity input-wrapper quantity-input vertical-align-middle'>
              Suggested Cases:
              <input class='input' type='number'
                data-testid='product-case-quantity'
                bind:value={product.case_quantity} />
            </span>
          </div>
        </span>
      {/if}
    {/each}
  </div>
  {/if}
</div>
